var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"div_title"},[_vm._v("搜索")]),_vm._v(" "),_c('UCPOIResultPaging',{ref:"ucResultPaging"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }